import template from './find-invoice.html';
import controller from './find-invoice.controller';
import './find-invoice.scss';

let FindInvoiceComponent = {
  bindings: {},
  template,
  controller
};

export default FindInvoiceComponent;



// WEBPACK FOOTER //
// ./src/app/pages/find-invoice/find-invoice.component.js